import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import classList from 'flarum/common/utils/classList';
import { t } from '../../../utils/settings';
/**
 * O ícone do emblema dentro de uma medalha redonda na cor do tipo — ouro,
 * prata ou bronze. Um emblema com imagem
 * (definida no admin) mostra a imagem no lugar do ícone. O tipo também vai no
 * `title`, para não depender só da cor.
 */
export default class BadgeMedal extends Component {
  view() {
    const {
      badge,
      size = 'medium',
      className
    } = this.attrs;
    const type = badge.type() || 'bronze';
    // Só http(s): o servidor já valida, e isto não deixa passar outro esquema.
    const imageUrl = badge.imageUrl();
    const image = imageUrl && /^https?:\/\//i.test(imageUrl) ? imageUrl : null;
    return m("span", {
      className: classList('CanelaBadgeMedal', `CanelaBadgeMedal--${type}`, `CanelaBadgeMedal--${size}`, className, {
        'CanelaBadgeMedal--image': image
      }),
      title: t(`badges.types.${type}`)
    }, image ? m("img", {
      className: "CanelaBadgeMedal-image",
      src: image,
      alt: "",
      loading: "lazy"
    }) : m(Icon, {
      name: badge.icon() || 'fas fa-certificate',
      className: "CanelaBadgeMedal-icon"
    }));
  }
}
flarum.reg.add('ramon-canela', 'forum/features/badges/components/BadgeMedal', BadgeMedal);